/**
 * Participant schedule workflow labels (endorsed, contacting, scheduled, …).
 * Colors come from `@/shared/lib/status-visual-palette` (shared with Schedule + Scheduler KPIs).
 */

import { getParticipantSchedulePillClass } from '@/shared/lib/status-visual-palette';

export const getStatusColor = (status: string): string =>
  getParticipantSchedulePillClass(status);

export const formatStatusDisplay = (status: string | null | undefined): string => {
  if (!status) return 'N/A';
  const statusLower = status.toLowerCase();
  if (statusLower === 'contacting') {
    return 'Scheduling';
  }
  if (statusLower === 'blocked') {
    return 'Do Not Hire';
  }
  if (
    statusLower === 'max_overbooks_reached' ||
    statusLower === 'overbooked'
  ) {
    return 'Overbooked';
  }
  if (statusLower === 'reschedule') {
    return 'Pending Reschedule';
  }
  if (statusLower === 'rescheduled') {
    return 'Rescheduled';
  }
  return status
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
